module.exports = __webpack_public_path__ + "static/media/02_720.d01cf269.jpeg";